import { Injectable } from '@angular/core';
import { FileElement } from '../interfaces/models/fileExplorer.model';
import { BehaviorSubject, Observable } from 'rxjs';
import { v4 as uuidv4 } from 'uuid';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';




@Injectable({
  providedIn: 'root'
})
export class FileServiceService {
  private domain = environment.domain;
  private map = new Map<string, FileElement>()
  constructor(private http: HttpClient) { }
  add(fileElement: FileElement) {
    fileElement.id = uuidv4();
    this.map.set(fileElement.id, this.clone(fileElement))
    console.log("map", this.map);
    return fileElement
  }
  addList(fileElement: FileElement[]) {
    const map = new Map(fileElement.map(item => [item.id, item]));
    this.map = map as Map<string, FileElement>;
    console.log("map", map);
  }

  delete(id: string) {
    this.map.delete(id)
  }

  update(id: string, update: Partial<FileElement>) {
    let element = this.map.get(id) as FileElement
    element = Object.assign(element, update)
    this.map.set(element.id as string, element)
    this.syncRename(element);

  }

  private querySubject: BehaviorSubject<FileElement[]> | undefined
  queryInFolder(folderId: string) {
    console.log("queryInFolder", folderId);
    const result: FileElement[] = []
    this.map.forEach(element => {
      if (element.parent === folderId) {
        result.push(this.clone(element))
      }
    })
    if (!this.querySubject) {
      this.querySubject = new BehaviorSubject(result)
    } else {
      this.querySubject.next(result)
    }
    return this.querySubject.asObservable()
  }

  get(id: string) {
    return this.map.get(id)
  }

  clone(element: FileElement) {
    return JSON.parse(JSON.stringify(element))
  }
  getFilesList(strategyId: number) {
    return this.http.get(this.domain + `strategies/${strategyId}/explorer/flat`);

  }

  downloaldElement(element: FileElement) {
    //update the url with the correct one
    return this.http.get(`${this.domain}${element?.download_link}`, {
      responseType: 'blob'
    });
  }

  syncRename(fileElement: FileElement) {
    // return this.http.post(this.domain + `strategies/${fileElement.strategyId}/explorer/rename`, fileElement);

  }
}
